import { TPhaLocType } from '../models/b2b/payments';
export const isT2CPrimaryPresent = (linesOfCredit, creditCards) => {
    var _a, _b;
    const hasPrimaryT2cCreditCard = (_a = creditCards === null || creditCards === void 0 ? void 0 : creditCards.some((creditCard) => creditCard.t2cPrimary)) !== null && _a !== void 0 ? _a : false;
    const hasPrimaryT2cLineOfCredit = (_b = linesOfCredit === null || linesOfCredit === void 0 ? void 0 : linesOfCredit.some((lineOfCredit) => lineOfCredit.t2cPrimary)) !== null && _b !== void 0 ? _b : false;
    return hasPrimaryT2cCreditCard || hasPrimaryT2cLineOfCredit;
};
export const determineT2CPrimaryForPHA = (locType, t2CPrimaryPresent) => {
    return !t2CPrimaryPresent && (locType === null || locType === void 0 ? void 0 : locType.toUpperCase()) !== TPhaLocType.PROJECT;
};
